import './tile-teaser-list.scss';

import { A11y, Navigation } from 'swiper/modules';

class TileTeaserList {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-tileteaserlist'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$tileTeaserList = $element;
        this.$tileTeaserListSlides = this.$tileTeaserList.querySelectorAll('[' + this.settings.initAttr + '="slide"]');
        this.tileTeaserListSlider = null;

        this.resizeHandler = window.resizeHandler;
        this.sliderActive = false;

        if (this.$tileTeaserListSlides.length > 1) {
            import(
                /* webpackChunkName: "slider/slider.js" */
                './../../components/slider/slider').then(({ Slider }) => {
                this.Slider = Slider;
                this.initialize();
            });
        }
        // this.initialize();
    }

    initialize () {
        this.checkSize();
        this.resizeHandler.customFunctions.push(() => {
            this.checkSize();
        });
    }

    checkSize () {
        if (window.innerWidth < 768 && this.$tileTeaserListSlides.length > 1) {
            if (this.sliderActive === false) {
                this.initSlider();
            }
        } else if (window.innerWidth < 1440 && this.$tileTeaserListSlides.length > 2) {
            if (this.sliderActive === false) {
                this.initSlider();
            }
        } else if (window.innerWidth >= 1440 && this.$tileTeaserListSlides.length > 3) {
            if (this.sliderActive === false) {
                this.initSlider();
            }
        } else {
            if (this.sliderActive === true) {
                this.destroySlider();
                this.sliderActive = false;
            }
        }
    }

    initSlider () {
        this.tileTeaserListSlider = new this.Slider(this.$tileTeaserList, {
            modules: [A11y, Navigation],
            speed: 500,
            slidesPerView: 'auto',
            slidesPerGroup: 1,
            centeredSlides: false,
            centeredSlidesBounds: true,
            initAttr: this.settings.initAttr,
            centerInsufficientSlides: true,
            breakpoints: {
                320: {
                    centeredSlides: true
                },
                768: {
                    slidesPerGroup: 2
                },
                1440: {
                    slidesPerGroup: 3
                }
            }
        });

        this.sliderActive = true;
    }

    destroySlider () {
        if (typeof this.tileTeaserListSlider !== 'undefined' && this.tileTeaserListSlider !== null) {
            this.tileTeaserListSlider.destroy();
        }
    }
}

export { TileTeaserList };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$tileTeaserList = $context.querySelectorAll('[data-tileteaserlist="root"]');
        for (let i = 0; i < $$tileTeaserList.length; i++) {
            const $tileTeaserList = $$tileTeaserList[i];

            const tileTeaserListAPI = new TileTeaserList($tileTeaserList);
            $tileTeaserList.API = tileTeaserListAPI;
        }
    }
});
